<template>
  <v-layout>
    <v-flex>
      <v-form ref="form" v-model="valid">

        <div class="previous" v-for="(device, counter) in document.devices" v-bind:key="counter">
          <v-card class="mx-auto mb-5" outlined>
            <v-card-actions>
              <div class="overline">Nr.crt. {{ counter + 1 }}</div>
              <v-spacer></v-spacer>
              <v-btn text @click="deleteDevice(counter)" color="orange">Sterge</v-btn>
            </v-card-actions>


            <v-list-item>
              <v-list-item-content>
                <v-row>
                  <v-col cols="12" md="2">
                    <v-text-field label="Tip aparat" v-model="device.deviceType" :rules="requiredRules" required>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-text-field label="Debit" v-model="device.flow" :rules="requiredRules" required>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-text-field label="Furnizor" v-model="device.provider" :rules="requiredRules" required>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-text-field label="Nr. Certificat" v-model="device.qualityCertificateNumber"
                      :rules="requiredRules" required>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-text-field label="Data Certificat" v-model="device.qualityCertificateDate" :rules="requiredRules"
                      required>
                    </v-text-field>
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </div>

        <v-layout justify-end>
          <v-btn justify-end @click="addDevice()" color="primary" class="mr-2">Produs Nou</v-btn>

        </v-layout>

        <SignaturePad ref="signatureRef" />

        <div class="text-xs-right">
          <v-btn @click="submit" color="primary">Salvare</v-btn>
          <v-btn @click="preview" color="primary">Previzualizare</v-btn>
        </div>
      </v-form>
    </v-flex>
  </v-layout>
</template>

<script>
import SignaturePad from '@/components/documents/SignaturePad.vue';
import { busEvent } from '../../main';
import { hasAccess, PERMISSION_LEVEL_ADMIN } from '../../utils/permissions';

export default {
  components: {
    SignaturePad,
  },

  data() {
    return {
      show: hasAccess(PERMISSION_LEVEL_ADMIN),
      valid: true,
      document: {
        type: 'pv-iugn-srb',

        devices: [{
          deviceType: '',
          flow: '',
          provider: '',
          qualityCertificateNumber: '',
          qualityCertificateDate: '',
        }],

      },
      requiredRules: [
        (element) => {
          if (element.trim() === '') return 'Campul trebuie completat.';
          return true;
        },
      ],
    };
  },

  async created() {
    // check if we're on edit screen
    if (this.$route.name === 'Editare PV IUGN SRB') {
      const document = await this.$store.dispatch('documents/getDocument', {
        clientId: this.$route.params.clientId,
        documentId: this.$route.params.id,
      });

      this.document = {
        ...document.props,
        documentId: document.id,
        number: document.number,
      };
      this.$refs.signatureRef.setSignature(document.props.signature);
    } else {
      const lastDocument = await this.$store.dispatch(
        'documents/getLastDocument',
        {
          documentType: 'pv-iugn-srb',
        }
      );

      this.document.contractNr = lastDocument.number + 1;
    }
  },
  methods: {
    submit() {
      if (this.$refs.form.validate() && this.valid) {
        this.document.signature = this.$refs.signatureRef.getSignature();

        if (this.$route.name === 'Editare PV IUGN SRB') {
          this.$store
            .dispatch('documents/update', {
              clientId: this.$route.params.clientId,
              body: this.document,
            })
            .then(() => {
              busEvent.$emit(
                'succesPopupCreated',
                'PF IUGN a fost editat'
              );
              this.$router.back();
            });
        } else {
          this.$store
            .dispatch('documents/create', {
              clientId: this.$route.params.clientId,
              body: this.document,
            })
            .then(() => {
              busEvent.$emit('succesPopupCreated', 'PF IUGN a fost creat');
              this.$router.back();
            });
        }
      }
    },
    async preview() {
      if (this.$refs.form.validate() && this.valid) {
        this.document.signature = this.$refs.signatureRef.getSignature();

        const response = await this.$store.dispatch('documents/preview', {
          clientId: this.$route.params.clientId,
          body: this.document,
        });

        const fileURL = window.URL.createObjectURL(new Blob([response.data]));
        const fileLink = document.createElement('a');
        fileLink.href = fileURL;
        const fileName =
          response.headers['content-disposition'].match("filename='(.*)'");
        fileLink.setAttribute('download', fileName[1]);
        document.body.appendChild(fileLink);
        fileLink.click();
        fileLink.remove();
      }
    },
    addDevice() {
      this.document.devices.push({
        deviceType: '',
        flow: '',
        provider: '',
        qualityCertificateNumber: '',
        qualityCertificateDate: '',
      });
    },
    deleteDevice(counter) {
      this.document.devices.splice(counter, 1);
    },
  },
};
</script>

<style></style>
